<div class="flex flex-col w-full">
  @if(imgUrl.length > 0){
    <div class="block sm:hidden">
      <img class="w-full rounded-[36px] object-contain"
           [ngSrc]="imgUrl"
           width="384"
           height="265"
           priority
           alt=""/>
    </div>
    <div class="hidden sm:block">
      <img class="rounded-[46px] object-contain"
           [ngSrc]="imgUrl"
           width="1203"
           height="643"
           priority
           alt=""/>
    </div>

  }
</div>
